/**
 * @generated SignedSource<<24fee5ed14561a7eaac763058834d973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraLabelsField_Platform$data = {
  readonly id: string;
  readonly " $fragmentType": "JiraLabelsField_Platform";
};
export type JiraLabelsField_Platform$key = {
  readonly " $data"?: JiraLabelsField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraLabelsField_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraLabelsField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraLabelsField"
};

(node as any).hash = "abec5e1ff0707b5a460966357bebf690";

export default node;
